import { useAppSelector } from './hooks';
import { getDateFormat, getDateTimeFormat, getDateTimeShortFormat } from '../utils/dateFormatter';

/**
 * Custom hook to get date format patterns based on user's language preference
 * This hook integrates with the Redux store to provide locale-specific date formats
 */
export const useDateFormat = () => {
  const currentLanguage = useAppSelector((state) => state.language.current);

  return {
    dateFormat: getDateFormat(currentLanguage),
    dateTimeFormat: getDateTimeFormat(currentLanguage),
    dateTimeShortFormat: getDateTimeShortFormat(currentLanguage),
    language: currentLanguage
  };
};

